import { useCallback, useState } from "react";

import { InitialOrderDataPart } from "../../constants";
import { TLoadedInitialData } from "../../types";

type TInitialDataLoadedReturn = {
  loadedInitialData: TLoadedInitialData;
  setInitialDataPartLoaded: (part: InitialOrderDataPart) => void;
};

const useIsInitialDataLoaded = (): TInitialDataLoadedReturn => {
  const [loadedInitialData, setLoadedInitialData] = useState<TLoadedInitialData>({});

  const setInitialDataPartLoaded = useCallback((part: InitialOrderDataPart) => {
    setLoadedInitialData((oldParts) => ({ ...oldParts, [part]: true }));
  }, []);

  return { loadedInitialData, setInitialDataPartLoaded };
};
export default useIsInitialDataLoaded;
